const projetcs = [
  {
    name: "Life-Advise",
    description:
      "offline first , full featured quotes generator web app to get some wonderful advice about life, success, money ...etc",
    image: "assets/life.png",
    liveLink: "https://life-advise.pages.dev",
    SourceLink: "https://github.com/osama865/life-advice-client",
  },
  {
    name: "netflix clone",
    description:
      "Complete Netflix clone with filters to search films and series, Based on ReactJs and firebase to handle database and authentication.",
    image: "assets/netflix.png",
    liveLink: "https://os-netflix.pages.dev",
    SourceLink: "https://o-netflix.pages.dev",
  },
  {
    name: "Restaurant website",
    description:
      "Attractive Restaurant website with all pages that needed by your customers, menu, about, gallary and contact. So they can found everything about your restaurant.",
    image: "assets/restaurant.png",
    liveLink: "https://assemble-res.pages.dev",
    SourceLink: "https://github.com/osama865/assemble-rest",
  },
  {
    name: "Basic Amazon Clone",
    description:
      "not Complete amazon clone based on react and firebase and many other",
    image: "assets/amazon.png",
    liveLink: "https://o-amzn.pages.dev",
    SourceLink: "https://github.com/osama865/Amazon",
  },
  {
    name: "Portfolio",
    description:
      "My personal Website that contains all my informations and projects, ",
    image: "assets/portoflio.png",
    liveLink: "https://o-portfolio.pages.dev",
    SourceLink: "https://github.com/osama865/Projects",
  },
  {
    name: "rental hotel rooms",
    description:
      "featured hotel rooms web app to look for a rooms to rent for your holiday",
    image: "assets/hotel.png",
    liveLink: "https://os-hotel.pages.dev",
    SourceLink: "https://github.com/osama865/Hotel",
  },
  {
    name: "Chat web app",
    description:
      "Funny chat app to chat with your friends and create rooms and joins others rooms based on react and node js and socket.io",
    image: "assets/Chat2.png",
    liveLink: "https://o-chatting.pages.dev",
    SourceLink: "https://github.com/osama865/Chat-Room-client",
  },
  {
    name: "Galarey",
    description: "simple Galarey app to store your images there and share them",
    image: "assets/firegram.png",
    liveLink: "https://galarey.pages.dev",
    SourceLink: "https://github.com/osama865/Galarey",
  },
  {
    name: "Basic weather app",
    description:
      "Basic weather app to get the weather status about specific country or city",
    image: "assets/weather.png",
    liveLink: "https://o-weather.pages.dev",
    SourceLink: "https://github.com/osama865/PWA_Weather",
  },
  {
    name: "simple recipes PWA",
    description:
      "simple app to save food recipes and share it with your friends",
    image: "assets/food.png",
    liveLink: "https://o-food.pages.dev",
    SourceLink: "https://github.com/osama865/PWA_FOOD_APP",
  },
  {
    name: "GYM landing page",
    description: "nice landing page for your GYM",
    image: "assets/gym.png",
    liveLink: "https://o-gym.pages.dev",
    SourceLink: "https://github.com/osama865/GYM",
  },
  {
    name: "AOS-testing",
    description:
      "Simple Website For Testing Different Types Of Animations Provided by AOS library, animation-on-scroll",
    image: "assets/aos.png",
    liveLink: "https://aos-testing.pages.dev",
    SourceLink: "#",
  },
];

export default projetcs